export const setContainersPosition = (container, config) => {
  container.x = config.x;
  container.y = config.y;
};
